import { Box, Typography } from "@material-ui/core";
import * as React from "react";

import { registrationFieldLabels } from "@/components/property_registration/RegistrationContext";
import theme from "@/theme";

export const PropertyEditErrorSummary: React.FC<{ errors: Record<string, unknown> }> = ({ errors }) => {
  const entries = Object.entries(errors).filter(
    ([, error]) => error && typeof error === "object" && "message" in error
  );
  if (!entries.length) return null;
  return (
    <Box role="alert" mt={3} p={2} borderRadius={8} bgcolor={theme.palette.semantic["status/error-bg"]}>
      <Typography variant="h4" color="error">
        入力内容を確認してください
      </Typography>
      <ul style={{ paddingLeft: 20, margin: "8px 0 0" }}>
        {entries.map(([key, error]) => (
          <li key={key}>
            <button
              type="button"
              style={{
                background: "none",
                border: 0,
                padding: 0,
                font: "inherit",
                fontSize: 12,
                color: theme.palette.error.main,
                textAlign: "left",
                cursor: "pointer",
              }}
              onClick={() => {
                const row = Array.from(document.querySelectorAll<HTMLElement>("[data-registration-field]")).find(
                  (el) => el.dataset.registrationField === key
                );
                row?.scrollIntoView?.({ block: "center" });
                row?.querySelector<HTMLButtonElement>("button")?.click();
              }}
            >
              {registrationFieldLabels[key] || key}：
              {String((error as { message?: string }).message || "入力内容を確認してください")}
            </button>
          </li>
        ))}
      </ul>
    </Box>
  );
};
